var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.613,
    height: 63.613,
    viewBox: "0 0 63.613 63.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.047,
    y1: 0.023,
    x2: 0.946,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 63.613,
    height: 63.613,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M59.039,63.618H2.272a2.278,2.278,0,0,1,0-4.555H4.543V52.7a2.275,2.275,0,1,1,4.549,0v6.361h9.486V41.416a2.275,2.275,0,1,1,4.549,0V59.062H33.651V31.784a2.275,2.275,0,1,1,4.549,0V59.062H48.553V21.492a2.278,2.278,0,1,1,4.555,0v37.57h5.931a2.278,2.278,0,0,1,0,4.555m-8.208-48.28a2.278,2.278,0,0,1-2.278-2.272v-6.2l-6.706,5.906a2.279,2.279,0,1,1-3.089-3.35l8.753-8.069a4.736,4.736,0,0,1,6.6-.03L62.88,9.431a2.276,2.276,0,1,1-3.089,3.344L53.109,6.59v6.476a2.278,2.278,0,0,1-2.278,2.272",
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon3);
export default __webpack_public_path__ + "static/media/social_icon3.952a9c7101a43c0859848cbe4e48c006.svg";
export { ForwardRef as ReactComponent };